export const onboarding = {
  description: 'You are now free to use PrayerStream.',
  groups_confirmation_title: 'Community Groups Are Set',
  skipped_groups_title: "You're All Set!",
  thank_you: 'Thank you!',
} as const;

export type OnboardingNamespace = Record<keyof typeof onboarding, string>;
